import { get } from 'lodash';
import { type AppState } from '../types';

export const getCustomRceColors = (state: AppState): string[] =>
  get(state, 'rceSettings.colorSettings.customColors', []);
